'use client'

import { NumberInput as MantineNumberInput, NumberInputProps } from '@mantine/core'

const defaultProps = {
  fixedDecimalScale: true,
  size: 'md',
  step: 10000,
  stepHoldDelay: 500,
  stepHoldInterval: 100,
  thousandSeparator: ' ',
  thousandsGroupStyle: 'thousand' as const,
}

export const NumberInput: React.FC<NumberInputProps> = (props) => <MantineNumberInput {...defaultProps} {...props} />
